import React from 'react';
import './index.scss';
import clsx from 'clsx';

import SpPopUp from 'components/molecules/SpPopUp';
import RequiredOrOptionalIcon from '../../atoms/Icon/RequiredOrOptionalIcon';

const SpInputItem = ({
    title,
    subTitle,
    // list = [],
    children,
    invisible,
    label,
    questionMark,
    popUpTitle,
    popUpDetail,
    // type
}) => {
    const DispTitle = () => {
        return Array.isArray(title)
            ? title.map(line => (
                <span key={line} className="">
                    {line}
                    <br />
                </span>
            ))
            : <>{title}</>;
    };

    const DispSubTitle = () => {
        return(
            <div className='subTitle'>{subTitle}</div>
        );
    };

    return (
        !invisible&&
        <div className="SpInputItem">
            <div className="SITM-title">
                <DispTitle />
                {<RequiredOrOptionalIcon label={label} />}
                <span 
                    className={clsx('RequiredOrOptionalIcon',
                        { qShow: questionMark === false })}>
                    <SpPopUp title={popUpTitle} children={popUpDetail}/>
                </span>
                <DispSubTitle />
            </div>
            <div className="SITM-item">
                {/* <DispChild /> */}
                {children}
            </div>
        </div>
    );
};

export default SpInputItem;